import { h } from '@stencil/core';
import { EnvironmentTableCell } from './environment-table-cell';
export const EnvironmentTableRow = (characteristicRecord) => {
  const { charName, charValue } = characteristicRecord || {};
  return (h("div", { class: "envsection_row envsection_characteristic-row" }, h("div", { class: "envsection_cell env-characteristic" }, h(EnvironmentTableCell, Object.assign({}, charName))), h("div", { class: "envsection_cell env-value" }, h(EnvironmentTableCell, Object.assign({}, charValue)))));
};
